import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
  formData = [];
  totalCount = 1;
  bookingDetails: any;
  @ViewChild('failedDialog') failedCall!: TemplateRef<any>;
  country = '';
  requiredHtml = '';

  constructor(private storage: StorageService, private apiService: ApiService, public dialog: MatDialog, private router: Router, private spinner: NgxSpinnerService) {

  }

  async submitForm(event: any) {
    this.spinner.show();
    let submitData = {
      "form_id": this.bookingDetails.form_id.toString(),
      "booking_id": this.bookingDetails.booking_id.toString(),
      "noapplicant": this.totalCount.toString(),
      "applicants": event
    };
    await this.apiService.saveForm(submitData).then(
      (data: any) => {
        if (data["success"]) {
          this.router.navigate(['/form-success']);
          this.spinner.hide();
        } else {
          this.showFailedDialog();
          this.spinner.hide();
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.showFailedDialog();
      }
    );
  };

  showFailedDialog() {
    let dialogRef = this.dialog.open(this.failedCall, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result === 'yes') {
        } else if (result === 'no') {

        }
      }
    });
  }

  //Go to track appointment component
  goToTrack() {
    this.router.navigate(['/track-appointment']);
  }

  ngOnInit() {

    let data = JSON.parse(this.storage.get('form_data') || '[]');
    this.requiredHtml = data?.data?.entity_details[0].custom_text;
    this.country = data?.data?.title;
    this.bookingDetails = JSON.parse(this.storage.get('booking_details') || '{}');
    this.formData = data?.data?.elements;
    if (Object.keys(this.bookingDetails).length > 0) {
      this.totalCount = this.bookingDetails.total_count;
    } else {
    }
  }

}
